import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PageAudio } from './page-audio';

@NgModule({
  declarations: [
    PageAudio,
  ],
  imports: [
    IonicPageModule.forChild(PageAudio),
  ],
  exports: [
    PageAudio
  ]
})
export class PageAudioModule {}



// WEBPACK FOOTER //
// ./src/pages/page-audio/page-audio.module.ts